import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PageResponse} from '../../../shared/commons/page-response';
import {ActivityLogDto} from '../../../../generated-model/models';

@Injectable({providedIn: 'root'})
export class ActivityLogListService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/settings/activity-logs';

  getAll(page: number, size: number, search?: string): Observable<PageResponse<ActivityLogDto>> {
    let params = new HttpParams().set('page', page).set('size', size);
    if (search && search.trim()) {
      params = params.set('term', search.trim());
    }
    return this.http.get<PageResponse<ActivityLogDto>>(this.apiUrl, {params});
  }

  getById(id: number): Observable<ActivityLogDto> {
    return this.http.get<ActivityLogDto>(`${this.apiUrl}/${id}`);
  }

  create(dto: ActivityLogDto): Observable<ActivityLogDto> {
    return this.http.post<ActivityLogDto>(this.apiUrl, dto);
  }

  update(id: number, dto: ActivityLogDto): Observable<ActivityLogDto> {
    return this.http.put<ActivityLogDto>(`${this.apiUrl}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
